// Styles
import './product-carousel.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductCarousel = context => {
  const product_carousel = context.closest('.shopify-section');
  if (!product_carousel) return;

  const sliderContainer = product_carousel.querySelector('.product-carousel__container');

  let sizeUltraDesktop = 3.6;
  let sizeDesktop = 3.2;
  let sizeTablet = 2.6;
  let sizeMobile = 1.4;

  if (sliderContainer.classList.contains('small')) {
    sizeUltraDesktop = 5.8;
    sizeDesktop = 5.5;
    sizeTablet = 3.9;
    sizeMobile = 1.8;
  }

  if (sliderContainer) {
    new Swiper(sliderContainer, {
      loop: false,
      navigation: {
        nextEl: sliderContainer.querySelector('.carousel-icon.icon-chevron-right'),
        prevEl: sliderContainer.querySelector('.carousel-icon.icon-chevron-left'),
      },
      slidesPerView: sizeMobile,
      spaceBetween: 20,
      preventClicks: false,
      breakpoints: {
        768: {
          slidesPerView: sizeTablet
        },
        1024: {
          slidesPerView: sizeDesktop,
          spaceBetween: 16
        },
        1920: {
          slidesPerView: sizeUltraDesktop
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-carousel__container'), (el) => {
    window.dAgency.initProductCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-carousel__container'), (el) => {
      window.dAgency.initProductCarousel(el);
    });
  });
}
const recommendedActive = document.querySelector(".product-carousel__container--recommended");
if (recommendedActive) {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-carousel__container--recommended');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          Array.from(document.querySelectorAll('.product-carousel__container--recommended'))
            .map(el => window.dAgency.initProductCarousel(el));

          var proxy_link = new CustomEvent("ProxyLink");
          window.dispatchEvent(proxy_link);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-carousel__container--recommended');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);
}
